/* Types */
const actionTypes = {
  SET_PAGELOADING: "SET_PAGELOADING",
} as const;

export type LoadingMode = "blocking" | "non-blocking";

export type PageLoadingState = {
  show: boolean;
  mode?: LoadingMode;
};

type Action = {
  type: typeof actionTypes.SET_PAGELOADING;
  payload: PageLoadingState;
};

/* Initial state */
const initialState: PageLoadingState = {
  show: false,
  mode: "blocking",
};

/* Actions */
const actions = {
  setPageLoading: (show: boolean, mode?: LoadingMode) => ({
    type: actionTypes.SET_PAGELOADING,
    payload: { show, mode },
  }),
};

/* Reducer */
const reducer = (state: PageLoadingState = initialState, action: Action): PageLoadingState => {
  switch (action.type) {
    case actionTypes.SET_PAGELOADING:
      return action.payload;
    default:
      return state;
  }
};

export { reducer, actions };
